import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgIoPlay({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				d="M4.15695 13.7501C3.96508 13.7497 3.77661 13.6994 3.61008 13.6041C3.23508 13.3916 3.00195 12.9791 3.00195 12.5313V3.46881C3.00195 3.01974 3.23508 2.60849 3.61008 2.39599C3.78058 2.298 3.97427 2.24761 4.17091 2.25009C4.36755 2.25256 4.55991 2.30781 4.72789 2.41006L12.4732 7.04631C12.6346 7.14752 12.7677 7.28807 12.8599 7.45479C12.9522 7.6215 13.0006 7.8089 13.0006 7.99943C13.0006 8.18996 12.9522 8.37736 12.8599 8.54408C12.7677 8.71079 12.6346 8.85134 12.4732 8.95256L4.72664 13.5901C4.55473 13.694 4.35783 13.7493 4.15695 13.7501Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgIoPlay;
